import { StripeStatusPipe } from './stripe.status.pipe';

export function StripeStatusFilter ( stripeStatusPipe : StripeStatusPipe ) {
  return ( value : 'A' | 'C' | 'P' | null ) : string => stripeStatusPipe.transform(value);
}